export default "__VITE_ASSET__fgjGiTgK__"